import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
`

export const CircularProgressContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
